@if (redemption$ | async; as redemption) {
  <div class="spacer spacer-6"></div>
  <app-svg-icon
    class="icon"
    [src]="'icons/124/circle-check.svg'"
    [svgStyle]="{ 'width.px': '124', 'height.px': '124' }"
  ></app-svg-icon>
  <div class="spacer spacer-3"></div>
  <p class="paragraph-highlight center">
    {{
      "PAGES.VOUCHER.SUCCESS"
        | translate: { value: (-(redemption.value || 0) | number: "1.2-2") }
    }}
  </p>
  <div class="spacer spacer-half"></div>
  <p class="body-small center">
    {{
      "PAGES.VOUCHER.REMAINING"
        | translate
          : { value: (redemption.voucher.value_current | number: "1.2-2") }
    }}
  </p>
  <div class="spacer spacer-2"></div>
  <p class="body-small center">
    {{ "PAGES.VOUCHER.SETTLEMENT" | translate }}
  </p>
  <div class="spacer spacer-4"></div>
  <app-button
    [label]="'PAGES.VOUCHER.NEXT_VOUCHER' | translate"
    [buttonType]="ButtonType.Blue"
    [fullWidth]="true"
    (action)="startOver()"
  ></app-button>
}
